<template>
    <div class="fiche-bu-monthly-news-block-ritual-details-subject w-100">
        <Panel v-model:collapsed="isCollapsed" :toggleable="!pdfBeingGenerated">
            <template #header>
                <div class="panel-header-clickable" @click="togglePanel">
                    <span class="bloc-index" v-if="!pdfBeingGenerated">{{ index + 1 }}</span>
                    <as-title class="title color-white"
                        :class="{ 'pl-5': !pdfBeingGenerated, 'pt-1 pb-1': pdfBeingGenerated }" :title="sujet.sujet"
                        :size="4" />
                    <div class="flex align-items-center ml-auto">
                        <Chip v-if="sujet.mustRead" :label="$t('rituals.ritual_details.ritual_bloc_must_read_label')"
                            class="must-read bg-error pl-3 pr-3" />
                    </div>
                </div>
            </template>


            <div class="background-primary-lighter">
                <div v-html="sujet.note" class="tinymce-content w-100 note p-3"></div>
            </div>
            <div v-if="!pdfBeingGenerated && sujet.fichiers?.length > 0" class="background-primary-lighter p-3">
                <as-title :title="$t('ficheBu.detail.monthly_news_block.documents')" :size="4" />
                <as-file v-for="fichier in sujet.fichiers" :key="fichier.id" class="col-6 header-file__content"
                    :fichier="fichier" @onDownload="onDownloadFichier" />
            </div>
        </Panel>
    </div>
</template>

<script>
import Card from 'primevue/card';
import Panel from 'primevue/panel';
import AsTitle from '../Elements/AsTitle.vue';
import AsFile from '../Elements/AsFile.vue';
import Chip from 'primevue/chip';
import fichiersServiceApi from "../../services/fichiersServiceApi";

export default {
    name: "FicheBuMonthlyNewsBlockRitualDetailsSubject",
    components: {
        AsTitle,
        AsFile,
        Card,
        Chip,
        Panel,
    },
    props: {
        pdfBeingGenerated: {
            type: Boolean,
            default: false,
        },
        sujet: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        defaultOpen: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isCollapsed: !this.defaultOpen,
        };
    },
    watch: {
        defaultOpen(newVal) {
            this.isCollapsed = !newVal;
        },
    },
    emits: ["toggle"],
    mixins: [fichiersServiceApi],
    methods: {
        togglePanel() {
            this.isCollapsed = !this.isCollapsed;
            this.$emit('toggle', this.index, this.isCollapsed);
        },
        onDownloadFichier(externalId, titre) {
            this.downloadFile(externalId, titre)
        },
    },
};
</script>

<style lang="scss">
@import "../../assets/styles/colors.scss";

.fiche-bu-monthly-news-block-ritual-details-subject {
    .p-toggleable-content {
        transition-duration: 0.15s !important;
        /* passe de 0.4s à 0.15s */
    }

    .p-panel {
        .p-panel-header {
            padding: 5px;
            border: 0;
            align-items: center;
            background: $primary_light_color !important;
        }

        .panel-header-clickable {
            display: flex;
            align-items: center;
            width: 100%;
            cursor: pointer;

            .bloc-index {
                position: relative !important;
                top: 0;
                left: 0;
                height: 35px;
                width: 35px;
                border-radius: 25px;
                background: $dark_font;
                color: white;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 1.2rem;
                font-weight: bold;
                border: 2px solid #fff;
            }

            .must-read {
                text-align: center;
                background: $evaluation_not_started_color;
            }
        }

        .p-panel-content {
            padding: 0 !important;
        }
    }
}
</style>
